import React, { useState } from "react";
import { Modal, Button, ProgressBar } from "react-bootstrap";

const steps = [
    {
        title: "Step 1: Create Your Resume",
        content: (
            <>
                <p className="font-weight-bold">
                    Build a Strong Profile to Stand Out
                </p>
                <p>
                    Start by uploading or creating your resume in the "My Resume" section.
                    A complete and well-formatted resume is essential for making a great
                    first impression on potential employers.
                </p>
                <p>
                    Make sure to include your work experience, education, skills, and any
                    relevant certifications or achievements that showcase your
                    qualifications.
                </p>
            </>
        ),
    },
    {
        title: "Step 2: Build Your Network",
        content: (
            <>
                <p>
                    Connect with Support Team Members in your industry who can provide
                    valuable insights, tips, and potential job leads.
                </p>
                <p>
                    The Network feature allows you to reach out to employed professionals
                    who have volunteered to help job seekers like you. Send them your
                    resume and ask for advice or connections.
                </p>
            </>
        ),
    },
    {
        title: "Step 3: Search and Apply for Jobs",
        content: (
            <>
                <p>
                    Browse available job postings in the "Jobs" section and apply to
                    positions that match your skills and career goals.
                </p>
                <p>
                    Use the search and filter options to find jobs in your preferred
                    industry, location, and experience level.
                </p>
                <p>
                    Stay active by checking your messages regularly for responses from
                    employers and Support Team Members.
                </p>
            </>
        ),
    },
];

export default function SeekerOnboardingModal({ show, onHide, onFinish }) {
    const [step, setStep] = useState(0);

    const handleNext = () => {
        if (step < steps.length - 1) setStep(step + 1);
        else {
            if (onFinish) onFinish(true);
            onHide();
            setStep(0); // reset for next open
        }
    };

    const handleBack = () => {
        if (step > 0) setStep(step - 1);
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{steps[step].title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ProgressBar now={((step + 1) / steps.length) * 100} className="mb-3" />
                {steps[step].content}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleBack} disabled={step === 0}>
                    Back
                </Button>
                <Button variant="primary" onClick={handleNext}>
                    {step === steps.length - 1 ? "Finish" : "Next"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
